// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"cf7cfc7e","636":"5f16c749"}[chunkId] + ".chunk.js";
};